// A waiting session's row, the same for every agent (spec "The sessions list"): its second line and its tooltip's.

import type { Session } from '../net/protocol';

/** A waiting session's second line, the same for every agent; what it asked goes in the tooltip (waitingAsk).
 *  The Mac and the iPhone: Session.waitingLine. */
export const WAITING_LINE = 'Waiting on you';

/** "Claude is waiting for your input", "Codex needs your attention": says only that it waits. */
const BOILERPLATE = /^([\w-]+( [\w-]+)? )?(is )?(waiting for|needs) (your )?(input|attention|you)\.?$/i;

/** What a waiting agent asked, without its name in front ("Claude Code: Allow Bash?" is "Allow Bash?"); a notice that
 *  only says it waits is "Claude Code is waiting for your input". The Mac and the iPhone: Session.ask. */
export function waitingAsk(s: Pick<Session, 'program' | 'notice'>): string {
  let text = (s.notice ?? '').trim();
  let who = s.program ?? '';
  const colon = text.indexOf(': ');
  const head = text.slice(0, colon);
  // a name in front: its program's, or one that reads like a name (every word capitalised: "Claude Code", not "Which file")
  if (colon > 0 && (head.toLowerCase() === who.toLowerCase() || /^[A-Z][\w-]*( [A-Z][\w-]*){0,2}$/.test(head))) {
    who = text.slice(0, colon);
    text = text.slice(colon + 2).trim();
  }
  if (!text || BOILERPLATE.test(text)) return `${who || 'It'} is waiting for your input`;
  return text[0].toUpperCase() + text.slice(1);
}
